import { c as _c } from "react/compiler-runtime";
import { IcoCheck24 } from '@onefootprint/icons';
import Text from '../../../../../../text';
import type { BaseSelectOption } from '../../../../base-select.types';
export type ItemProps = {
  option: BaseSelectOption;
  value?: BaseSelectOption;
  onSelect: () => void;
};
const Item = t0 => {
  const $ = _c(15);
  const {
    option,
    value,
    onSelect
  } = t0;
  const {
    label
  } = option;
  const selected = option.value === value?.value;
  let t1;
  if ($[0] !== onSelect) {
    t1 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onSelect();
      }
    };
    $[0] = onSelect;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label) {
    t2 = <Text variant="body-2" className="text-(--dropdown-color-primary)">{label}</Text>;
    $[2] = label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== selected) {
    t3 = selected ? <IcoCheck24 /> : null;
    $[4] = selected;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div>{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="fp-dropdown-item flex flex-row justify-between py-3 px-4 cursor-pointer">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onSelect || $[12] !== t1 || $[13] !== t5) {
    t6 = <div role="option" onClick={onSelect} onKeyDown={t1} tabIndex={0}>{t5}</div>;
    $[11] = onSelect;
    $[12] = t1;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default Item;